<nz-layout class="app-layout">
  <!--  <nz-sider class="menu-sidebar"-->
  <!--            nzCollapsible-->
  <!--            nzWidth="256px"-->
  <!--            nzBreakpoint="md"-->
  <!--            [(nzCollapsed)]="isCollapsed"-->
  <!--            (mouseover)="openMenu()"-->
  <!--            (mouseout)="closeMenu()"-->
  <!--            [nzTrigger]="null">-->
  <!--    <div class="sidebar-logo">-->
  <!--      <img src="assets/images/common/tripium_logo.png" alt="logo">-->
  <!--    </div>-->
  <!--    <app-menu [isCollapsed]="isCollapsed"></app-menu>-->
  <!--  </nz-sider>-->

  <!--  <nz-layout>-->
  <nz-header>
    <header class="main">
      <div class="left">
        <div class="sidebar-logo">
          <img src="assets/images/common/tripium.logo.svg" alt="logo" />
        </div>
        <div class="vendorSelector">
          <app-ml-vendor-selector></app-ml-vendor-selector>
        </div>
      </div>

      <div class="loginAsCompany">
        @if (adminLoggedAsCompany) {
          <button
            nz-button
            nzType="dashed"
            nzSize="large"
            class="loginAsCompany-btn"
            (click)="loginAsCompany()"
          >
            <div class="loginAsCompany-label">
              <div class="status">
                You Logged as "<b>{{ loggedCompanyDetails.administrator }}</b>" Company.
              </div>
              <div class="hint">Click here to Changes</div>
            </div>
          </button>
        }
      </div>

      <div class="right">
        <div class="userMenu">
          <div class="userGuide">
            <app-user-guide></app-user-guide>
          </div>
          <div class="app-header-username-avatar"
               nz-popover
               [nzPopoverTitle]="systemUpdate.title"
               [nzPopoverTrigger]="systemUpdate.hasUpdates() ? 'click' : null"
               nzPopoverPlacement="bottomRight"
               [nzPopoverContent]="updatesPopover"
               (nzPopoverVisibleChange)="onUpdatesPopoverVisible($event)">
            <nz-badge [nzCount]="msgCounter">
              <nz-avatar nzIcon="user" nzShape="circle"></nz-avatar>
            </nz-badge>
          </div>
          <ng-template #updatesPopover>
            <div class="system-updates-popover">
              <app-system-updates-list></app-system-updates-list>
            </div>
          </ng-template>
          <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
            <div>{{ currentUserName }}</div>
            <div><i nz-icon nzType="down"></i></div>
          </a>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <!--                <li nz-menu-item (click)="zoom(-1)">Zoom Out</li>-->
              <!--                <li nz-menu-item (click)="zoom(1)">Zoom In</li>-->
              <li nz-menu-item>
                <a href="/" target="_blank"> Open Inventory v1 </a>
              </li>
              <li nz-menu-item>
                <a (click)="accountDetails()"> Account Details </a>
              </li>
              @if (adminMode && !adminLoggedAsCompany) {
                <li nz-menu-item (click)="loginAsCompany()">Login as Company</li>
              }
              <li nz-menu-divider></li>
              <li nz-menu-item (click)="userLogOut()">Log Out</li>
            </ul>
          </nz-dropdown-menu>
        </div>
      </div>
    </header>

    <!--    <div nz-row>-->

    <!--      <div nz-col nzSpan="12">-->
    <!--        <div class="rt-menu">-->

    <!--          &lt;!&ndash;Admin logged in as company&ndash;&gt;-->
    <!--          -->

    <!--          &lt;!&ndash;User Manual&ndash;&gt;-->
    <!--          <div>-->
    <!--            <app-user-guide></app-user-guide>-->
    <!--&lt;!&ndash;            <button nz-button nzType="primary"&ndash;&gt;-->
    <!--&lt;!&ndash;                    nzShape="circle">&ndash;&gt;-->
    <!--&lt;!&ndash;&lt;!&ndash;                    (click)="UserGuide.open();"&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;              <i nz-icon nzType="question" nzTheme="outline"></i>&ndash;&gt;-->
    <!--&lt;!&ndash;            </button>&ndash;&gt;-->
    <!--          </div>-->

    <!--          &lt;!&ndash;Scale Control&ndash;&gt;-->
    <!--          <div>-->
    <!--            <nz-button-group>-->
    <!--              <button nz-button-->
    <!--                      nzType="primary"-->
    <!--                      nz-tooltip-->
    <!--                      nzTooltipPlacement="bottom"-->
    <!--                      nzTooltipTitle="Zoom Out"-->
    <!--                      [disabled]="currentZoom <= 80"-->
    <!--                      (click)="zoom(-1)">-->
    <!--                <i nz-icon nzType="zoom-out" nzTheme="outline"></i>-->
    <!--              </button>-->
    <!--              <button nz-button nzType="">{{currentZoom}}%</button>-->
    <!--              <button nz-button-->
    <!--                      nzType="primary"-->
    <!--                      nz-tooltip-->
    <!--                      nzTooltipPlacement="bottom"-->
    <!--                      nzTooltipTitle="Zoom In"-->
    <!--                      [disabled]="currentZoom >= 200"-->
    <!--                      (click)="zoom(1)">-->
    <!--                <i nz-icon nzType="zoom-in" nzTheme="outline"></i>-->
    <!--              </button>-->
    <!--            </nz-button-group>-->
    <!--          </div>-->

    <!--&lt;!&ndash;          <div>&ndash;&gt;-->
    <!--&lt;!&ndash;            <button nz-button&ndash;&gt;-->
    <!--&lt;!&ndash;                    nzType="default"&ndash;&gt;-->
    <!--&lt;!&ndash;                    nzShape="circle"&ndash;&gt;-->
    <!--&lt;!&ndash;                    nz-popover&ndash;&gt;-->
    <!--&lt;!&ndash;                    nzPopoverTitle="Change Scale"&ndash;&gt;-->
    <!--&lt;!&ndash;                    nzPopoverTrigger="click"&ndash;&gt;-->
    <!--&lt;!&ndash;                    [nzPopoverContent]="scaleCtrl">&ndash;&gt;-->
    <!--&lt;!&ndash;              <i nz-icon nzType="expand" nzTheme="outline"></i>&ndash;&gt;-->
    <!--&lt;!&ndash;            </button>&ndash;&gt;-->
    <!--&lt;!&ndash;            <ng-template #scaleCtrl>&ndash;&gt;-->
    <!--&lt;!&ndash;              <div style="height: 300px">&ndash;&gt;-->
    <!--&lt;!&ndash;                <nz-slider nzVertical&ndash;&gt;-->
    <!--&lt;!&ndash;                           nzMin="70"&ndash;&gt;-->
    <!--&lt;!&ndash;                           nzMax="150"&ndash;&gt;-->
    <!--&lt;!&ndash;                           [nzMarks]="marks"&ndash;&gt;-->
    <!--&lt;!&ndash;                           [nzStep]="null"&ndash;&gt;-->
    <!--&lt;!&ndash;                           (ngModelChange)="scale($event)"&ndash;&gt;-->
    <!--&lt;!&ndash;                           [(ngModel)]="currentZoom"></nz-slider>&ndash;&gt;-->
    <!--&lt;!&ndash;              </div>&ndash;&gt;-->
    <!--&lt;!&ndash;            </ng-template>&ndash;&gt;-->
    <!--&lt;!&ndash;          </div>&ndash;&gt;-->

    <!--          &lt;!&ndash;User Guide > &ndash;&gt;-->
    <!--&lt;!&ndash;          <div class="userGuide">&ndash;&gt;-->
    <!--&lt;!&ndash;            <button nz-button nzType="primary"&ndash;&gt;-->
    <!--&lt;!&ndash;                    nzShape="circle">&ndash;&gt;-->
    <!--&lt;!&ndash;&lt;!&ndash;                    (click)="USERGUIDE.open()"&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;              <i nz-icon nzType="question" nzTheme="outline"></i>&ndash;&gt;-->
    <!--&lt;!&ndash;            </button>&ndash;&gt;-->
    <!--&lt;!&ndash;          </div>&ndash;&gt;-->
    <!--          &lt;!&ndash;User Guide / &ndash;&gt;-->

    <!--          &lt;!&ndash;UserMenu&ndash;&gt;-->
    <!--          <div>-->
    <!--            <nz-badge [nzCount]="13" class="app-header-username-avatar">-->
    <!--              <nz-avatar nzIcon="user" [nzShape]="'shape'"></nz-avatar>-->
    <!--            </nz-badge>-->
    <!--            <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">-->
    <!--              {{currentUserName}}-->
    <!--              <i nz-icon nzType="down"></i>-->
    <!--            </a>-->
    <!--            <nz-dropdown-menu #menu="nzDropdownMenu">-->
    <!--              <ul nz-menu>-->
    <!--&lt;!&ndash;                <li nz-menu-item (click)="zoom(-1)">Zoom Out</li>&ndash;&gt;-->
    <!--&lt;!&ndash;                <li nz-menu-item (click)="zoom(1)">Zoom In</li>&ndash;&gt;-->
    <!--                @if (adminMode) {-->
    <!--                  <li nz-menu-item (click)="loginAsCompany()">Login as Company</li>-->
    <!--                }-->
    <!--                <li nz-menu-divider></li>-->
    <!--                <li nz-menu-item (click)="userLogOut()">-->
    <!--                  Log Out-->
    <!--                </li>-->
    <!--              </ul>-->
    <!--            </nz-dropdown-menu>-->
    <!--          </div>-->

    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </nz-header>

  <nz-layout>
    <nz-sider
      class="menu-sidebar"
      nzCollapsible
      nzWidth="256px"
      [(nzCollapsed)]="isCollapsed"
      (mouseover)="openMenu()"
      (mouseout)="closeMenu()"
      [nzTrigger]="null"
    >
      <!--              nzBreakpoint="md"-->
      <div class="menu-items">
        <app-menu [isCollapsed]="isCollapsed"></app-menu>
      </div>
    </nz-sider>

    <nz-layout class="inner-layout">
      <!--      <nz-layout class="header-descriptor">-->
      <!--        <header-descriptor></header-descriptor>-->
      <!--      </nz-layout>-->

      <nz-content>
        @if (bcAvailable) {
          <div class="breadcrumbs">
            <nz-breadcrumb [nzSeparator]="iconTemplate">
              <nz-breadcrumb-item>
                <i nz-icon nzType="home"></i>
              </nz-breadcrumb-item>

              @for (bcItem of BC; track bcItem) {
                <nz-breadcrumb-item>
                  @if (bcItem.url) {
                    <span>
                      <a [routerLink]="bcItem.url">{{ bcItem.title }}</a>
                    </span>
                  } @else {
                    <span>
                      {{ bcItem.title }}
                    </span>
                  }
                </nz-breadcrumb-item>
              }
            </nz-breadcrumb>
            <ng-template #iconTemplate>
              <i nz-icon nzType="caret-right" nzTheme="outline"></i>
            </ng-template>
          </div>
        }

        <!--        <div class="debug">-->
        <!--          <button (click)="d1()">Reset DB</button>-->
        <!--          <button (click)="d2()">Fill DB</button>-->
        <!--          <button (click)="d3()">Read DB (All)</button>-->
        <!--          <button (click)="d4('shows')">Read DB (Shows only)</button>-->
        <!--          <button (click)="d4('attractions')">Read DB (Attractions only)</button>-->
        <!--          <button (click)="d4('dining')">Read DB (Dining only)</button>-->
        <!--          <button (click)="d5()">Read DB (Shows by ID&CAT)</button>-->
        <!--        </div>-->

        <div>
          <!--          @if (debug) {-->
          <!--          <div class="debugger" style="padding: 20px;">-->
          <!--            <div>DEBUG mode</div>-->
          <!--            <a (click)="openImgEditor()">open editor</a>-->
          <!--          </div>-->
          <!--          }-->
          <router-outlet name="primary" class="child-outlets"></router-outlet>
          <!--[ngClass]="(atlDisplayShow) ? 'altActive' : ''"-->
        </div>
        <!--<router-outlet></router-outlet>-->
      </nz-content>
    </nz-layout>
  </nz-layout>
</nz-layout>

<nz-modal
  [(nzVisible)]="updatesModalVisible"
  [nzTitle]="systemUpdate.title"
  [nzWidth]="560"
  nzCentered
  [nzMaskClosable]="false"
  [nzKeyboard]="false"
  nzOkText="Got it"
  nzCancelText="Cancel"
  (nzOnOk)="onUpdatesAcknowledged()"
  (nzOnCancel)="onUpdatesCancelled()">
  <ng-container *nzModalContent>
    <p style="font-size: 16px; margin-bottom: 24px;">
      Please review the changes included in this release.
    </p>
    <app-system-updates-list></app-system-updates-list>
  </ng-container>
</nz-modal>
